module.exports = __webpack_public_path__ + "static/media/skinHazardousarts2.659568d7.jpg";